import type { CreditProgramKind } from './credit-program.ts'

import { type BillingMethod, isBillingMethod } from './billing-method.ts'
import { isCreditProgramKind } from './credit-program.ts'

export type MoneyBillingMethod = Exclude<BillingMethod, CreditProgramKind>

/**
 * Checks if a value is a billing method that is not a credit program
 */
export function isMoneyBillingMethod(
  value: BillingMethod
): value is MoneyBillingMethod {
  if (isBillingMethod(value)) {
    return !isCreditProgramKind(value)
  }
  return false
}

export function assertMoneyBillingMethod(
  value: BillingMethod
): asserts value is MoneyBillingMethod {
  if (!isMoneyBillingMethod(value)) {
    throw new Error('Value is not a money billing method')
  }
}
